import React, { useEffect, useState } from "react";
import {
    CogIcon,
    UserIcon,
    BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Stepper from "../Common/Stepper";
import { DetailsApi, createCustomerUserCall, createSingleCustomerUserCall, customerUserSubmitCall, deleteCustomerUser } from "../../services/redux/ApiActions";
import showNotification from "../../services/redux/NotifcationService";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import { emailRegex } from "../Common/EmailRegex";
import logo from '../../img/BBPS_Horizontal.png'


export default function StepFour() {
    const navigate = useNavigate();
    const details = useSelector((state) => state.details.details);
    const customerData = useSelector((state) => state.customerData.customerData);
    const containsPropretor = details?.result.businessType.toLowerCase().includes("proprietor");
    const containsPerson = details?.result.businessType.toLowerCase().includes("person");
    const containsPartnerShip = details?.result.businessType.toLowerCase().includes("partnership");
    const doesntContainsLiability = !details?.result.businessType.toLowerCase().includes("liability");
    const dispatch = useDispatch();

    const [forms, setForms] = useState([]);
    const [formIds, setFormIds] = useState([null]); // Track if each form has an ID

    useEffect(() => {

        if (details?.result && details?.result.customerUsers.length > 0) {
            setForms(
                details?.result.customerUsers.map((user) => ({
                    firstName: user.firstName || "",
                    lastName: user.lastName || "",
                    phone: user.phone || "",
                    email: user.email || "",
                    role: user.permissions || "",
                    isFirstNameFilled: user.firstName ? true : false,
                    isLastNameFilled: user.lastName ? true : false,
                    isPhoneFilled: user.phone ? true : false,
                    isEmailFilled: user.email ? true : false,
                    isRoleFilled: user.permissions ? true : false,
                    pan: user.pan || '',
                    aadharMsg: user.aadhaarStatus,
                    // aadhar: user.aadhaarStatus !== 'Verified' && user.aadhaarStatus === '-' ? '' : user.aadhaarStatus || '',
                    aadhar: user.aadhaarStatus !== 'Verified' && user.aadhaarStatus === '-' || user.aadhaarStatus !== 'Verified' && user.aadhaarStatus !== '-' ? '' : user.aadhaarStatus,
                    isAadhaarVerified: user.aadhaarStatus === 'Verified' && user.aadhaarStatus !== '-' ? true : false,
                    isAadharFailed: user.aadhaarStatus !== 'Verified' && user.aadhaarStatus !== '-' ? true : false,
                    id: user.id || ''
                }))
            );
        } else {
            // If details.partners is not available, initialize with an empty form
            setForms([
                {
                    firstName: "",
                    lastName: "",
                    phone: "",
                    email: "",
                    role: "",
                    isFirstNameFilled: false,
                    isLastNameFilled: false,
                    isPhoneFilled: false,
                    isEmailFilled: false,
                    isRoleFilled: false,
                    pan: '',
                    aadharMsg: '',
                    aadhar: '',
                    isAadhaarVerified: false,
                    isAadharFailed: false,
                    id: ''
                },
            ]);
        }
    }, [details]);

    const addNewForm = (form) => {
        // if (form.id === '' || form.id === null) {
        //     showNotification('Please save the current form before adding a new form', 'error')
        //     return;
        // }

        const currentForm = forms[forms.length - 1];
        if (currentForm.id !== '' || currentForm.id !== null && isFormFilled(currentForm)) {
            // Add a new form
            setForms(prevForms => [...prevForms, { id: '', firstName: '', lastName: '', phone: '', email: '', pan: '', aadhar: '', role: '' }]);
        } else {
            showNotification('Please save the user details before adding a new user.', 'error');
            return;
        }

        setForms([...forms, {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            role: '',
            isFirstNameFilled: false,
            isLastNameFilled: false,
            isPhoneFilled: false,
            isEmailFilled: false,
            isRoleFilled: false,
            pan: '',
            aadharMsg: '',
            aadhar: null,
            isAadhaarVerified: false,
            isAadharFailed: false,
            id: ''
        }]);
    }

    const removeForm = (index, form) => {
        console.log(form.id)
        const updatedForms = [...forms];
        updatedForms.splice(index, 1);
        setForms(updatedForms);
        if (form.id !== '') {
            deleteUser(form);
        }
    }

    // const handleChange = (index, e) => {
    //     const { name, value } = e.target;
    //     const updatedForms = [...forms];
    //     // console.log(e.target.id.split('-')[0])
    //     // Check if the input is a radio button
    //     if (name.startsWith('role')) {
    //         // If it is a radio button, update the 'role' field in the corresponding form
    //         updatedForms[index]['role'] = e.target.id.split('-')[0]; // Extract the role from the ID
    //     } else {
    //         // For other input types, update as before
    //         updatedForms[index][name] = name === 'phone' ? value.slice(0, 10).replace(/\D/g, '') : value; // Apply slice(0, 10) only to the phone field
    //         // Update the filled status based on whether the value is empty or not
    //         updatedForms[index][`is${name.charAt(0).toUpperCase()}${name.slice(1)}Filled`] = value.trim() !== "";
    //     }
    //     setForms(updatedForms);
    // };

    const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedForms = [...forms];
    let cleanedValue = value;

    // Special handling for radio buttons
    if (name.startsWith('role')) {
        updatedForms[index]['role'] = e.target.id.split('-')[0];
    } else {
        // Field-specific sanitization
        switch (name) {
            case 'phone':
                cleanedValue = value.slice(0, 10).replace(/\D/g, '');
                break;

            case 'pan':
                cleanedValue = value.toUpperCase().replace(/[^A-Z0-9]/gi, '').slice(0, 10);
                break;

            case 'aadhar':
                cleanedValue = value.replace(/\D/g, '').slice(0, 12);
                break;

            case 'firstName':
            case 'lastName':
                cleanedValue = value.replace(/[^A-Za-z\s]/g, '');
                break;

            case 'email':
            cleanedValue = value.replace(/[^A-Za-z0-9@+\.]/g, '');
            break;

            default:
                // No change to cleanedValue
                break;
        }

        updatedForms[index][name] = cleanedValue;

        // Set filled status
        updatedForms[index][`is${name.charAt(0).toUpperCase()}${name.slice(1)}Filled`] =
            cleanedValue.trim() !== '';
    }

    setForms(updatedForms);
};


    const isFormFilled = (form) => {
        return form.isFirstNameFilled && form.isLastNameFilled && form.isPhoneFilled && form.isEmailFilled && form.isRoleFilled;
    };

    const isFormValid = (form) => {
        return form.firstName.trim() !== '' &&
            form.lastName.trim() !== '' &&
            form.phone.trim() !== '' &&
            form.email.trim() !== '' &&
            form.role.trim() !== '' &&
            form.pan.trim() !== '';
    };
    const SkipStep = async () => {
        if (containsPropretor || containsPerson) {
            navigate('/Customer/Step4DeclarationPartner');
        } else if (containsPartnerShip && doesntContainsLiability) {
            navigate('/Customer/Step4DeclarationProperitor');
        } else {
            navigate('/Customer/Step5');
        }
    }
    const handleSubmit = async () => {
        if (formIds.some(id => id === '')) {
            showNotification('Please save the current entry before proceeding.', 'error');
        } else {
            const data = await dispatch(customerUserSubmitCall('', customerData?.token_chr, customerData.custId));
            if (data?.statusCode === 200) {
                await getDetails();
                showNotification('Success', 'success')
                if (containsPropretor || containsPerson) {
                    navigate('/Customer/Step4DeclarationPartner');
                } else if (containsPartnerShip && doesntContainsLiability) {
                    navigate('/Customer/Step4DeclarationProperitor');
                } else {
                    navigate('/Customer/Step5');
                }
            }
        }
        // Function to validate phone number format

        // const payload = forms.map(form => ({
        //     firstName: form.firstName,
        //     lastName: form.lastName,
        //     phone: form.phone,
        //     email: form.email,
        //     "customerId": `${customerData?.custId}`,
        //     "permissions": form.role,
        //     "selectedRoles": "",
        //     "otpSubscription": "",
        //     "createdAt": new Date(),
        //     "createdBy": "",
        //     "createdIp": "",
        //     "createdUserAgent": "",
        // }));
        // console.log(payload)

        // Check if any of the email fields are invalid
        // for (const form of forms) {
        //     if (!emailRegex.test(form.email)) {
        //         showNotification('Please enter a valid email', 'error');
        //         return;
        //     }
        // }

        // const data = await dispatch(createCustomerUserCall(payload, customerData?.token_chr, customerData.custId));
        // if (data?.statusCode === 200) {
        //     await getDetails();
        //     showNotification('Success', 'success')
        //     if (containsPropretor || containsPerson) {
        //         navigate('/Customer/Step4DeclarationPartner');
        //     } else if (containsPartnerShip && doesntContainsLiability) {
        //         navigate('/Customer/Step4DeclarationProperitor');
        //     } else {
        //         navigate('/Customer/Step5');
        //     }
        // }

    }

    const deleteUser = async (form) => {
        const data = await dispatch(deleteCustomerUser('', customerData?.token_chr, form.id));
        if (data.result === true) {
            console.log(data.result)
            getDetails();
            showNotification('User Deleted Successfully', 'success')
        }
    }

    const getDetails = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": customerData?.custId
        }
        // console.log(Payload)
        const data = await dispatch(DetailsApi(Payload, customerData?.token_chr, "customer"));
        dispatch(setDetailsData(data))
    }

    const SaveForm = async (form) => {
        const payload = {
            "id": form.id === '' ? 0 : form.id,
            "customerId": `${customerData?.custId}`,
            "firstName": form.firstName,
            "lastName": form.lastName,
            "phone": form.phone,
            "email": form.email,
            "permissions": form.role,
            "selectedRoles": "",
            "otpSubscription": "",
            "pan": form.pan,
            // "adhaar": form.aadhar !== 'Verified' && form.aadhar === '-' && form.isAadharFailed ? '' : form.aadhar,
            "adhaar": form.isAadhaarVerified === true ? null : form.aadhar,
            "createdAt": new Date(),
            "createdBy": "",
            "createdIp": "",
            "createdUserAgent": "",
        }
        console.log(payload)
        if (!isFormValid(form)) {
            showNotification('Please fill in all required fields', 'warning');
            return;
        }

        //  Check if any of the email fields are invalid
        for (const form of forms) {
            if (!emailRegex.test(form.email)) {
                showNotification('Please enter a valid email', 'error');
                return;
            }
        }
        const data = await dispatch(createSingleCustomerUserCall(payload, customerData?.token_chr, customerData.custId));
        if (data?.statusCode === 200) {
            getDetails();
            // showNotification('Success', 'success')
            if (data?.result.message.includes('does not match')) {
                console.log('includes')
                showNotification(data?.result.message, 'error')
            } else {
                showNotification(data?.result.message, 'success')
            }
            console.log(data)
            const formWithoutId = forms.find(form => form.id === undefined || form.id === '');

            if (formWithoutId) {
                // Set the ID for the form without an ID
                const updatedForms = forms.map(form => {
                    if (form === formWithoutId) {
                        return { ...form, id: data.result.data };
                    }
                    return form;
                });
                setForms(updatedForms);
            } else {
                console.error('No form found without an ID');
            }
            // await getDetails();
            // showNotification('Success', 'success')
            // if (containsPropretor || containsPerson) {
            //     navigate('/Customer/Step4DeclarationPartner');
            // } else if (containsPartnerShip && doesntContainsLiability) {
            //     navigate('/Customer/Step4DeclarationProperitor');
            // } else {
            //     navigate('/Customer/Step5');
            // }
        }
    }

    useEffect(() => {
        // Update form IDs array whenever forms change
        setFormIds(forms.map(form => form.id));
    }, [forms]);

    // Check if a specific form is filled and has an ID
    const isFormFilledAndHasId = (form) => {
        return form.id !== null && isFormFilled(form);
    };

    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <CustomerHeader />
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <Stepper />
                                <div className='bg-white mx-2 shadow-xl p-3 mt-4 rounded-lg'>

                                    <div className="grid grid-cols-12 gap-4">
 <div className="col-span-12 md:col-span-2 lg:col-span-2">
</div>
 <div className="col-span-12 md:col-span-8 lg:col-span-8">
 <div className="py-2 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">LIST OF USERS

                                        </h1>
                                    </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                                    <div style={{display:'flex',justifyContent:'right',marginTop:'-5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
                                    </div>
 </div>
                                    <div className="py-2 text-center">
                                        <h1 className="text-sm text-gray-600">Please add the list of users and their roles who will access the V2P application

                                        </h1>
                                    </div>
                                    <div className=' border-none border-collapse rounded-md'>
                                        <div className="flex justify-end">
                                            <button onClick={() => addNewForm()} className="vtpRm-action-button">
                                                <div className="flex">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                                    </svg>
                                                    <label className="hover:cursor-pointer">Add More Users</label>
                                                </div>
                                            </button>
                                        </div>
                                        {forms?.map((form, index) => (
                                            <div key={index}>
                                                <div className=" bg-gray-300 p-6 mt-2 mb-2 pb-8">
                                                    <div className="grid grid-cols-12 gap-4">
                                                        <div className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-6">
                                                            <div className="grid grid-cols-12 gap-4">
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <label htmlFor="firstName" className="block text-md font-medium leading-6 text-gray-900">First Name <span className="text-red-600">*</span></label>
                                                                    <CustomerInput name='firstName' onChange={(e) => handleChange(index, e)} value={form.firstName} placeHolder='Enter First Name' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <label htmlFor="lastName" className="block text-md font-medium leading-6 text-gray-900">Last Name <span className="text-red-600">*</span></label>
                                                                    <CustomerInput name='lastName' onChange={(e) => handleChange(index, e)} value={form.lastName} placeHolder='Enter Last Name' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <label htmlFor="phone" className="block text-md font-medium leading-6 text-gray-900">Phone <span className="text-red-600">*</span></label>
                                                                    <CustomerInput name='phone' onChange={(e) => handleChange(index, e)} value={form.phone} placeHolder='Enter Phone' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <label htmlFor="email" className="block text-md font-medium leading-6 text-gray-900">Email <span className="text-red-600">*</span></label>
                                                                    <CustomerInput name='email' value={form.email} onChange={(e) => handleChange(index, e)} placeHolder='Enter Email' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <label htmlFor="pan" className="block text-md font-medium leading-6 text-gray-900">PAN <span className="text-red-600">*</span></label>
                                                                    <CustomerInput name='pan' value={form.pan} onChange={(e) => handleChange(index, e)} placeHolder='Enter PAN Number' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="col-span-12 md:col-span-12 lg:col-span-6">
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'inline'
                                                                    }}>
                                                                        <label htmlFor="aadhar" className="block text-md font-medium leading-6 text-gray-900">Aadhaar
                                                                        </label>
                                                                        {form.isAadharFailed === true && (
                                                                            <button title={form.aadharMsg}>
                                                                                <svg color="red" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                                                                </svg>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <CustomerInput name='aadhar' disabled={form.isAadhaarVerified === true ? true : false} value={form.aadhar} onChange={(e) => handleChange(index, e)} placeHolder='Enter Aadhaar Number' inputStyles={{ padding: '12px' }} />
                                                                </div>
                                                                <div className="text-center col-span-12 md:col-span-12">
                                                                    <button onClick={() => SaveForm(form)} className="vtpRm-action-button">Save</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-6">
                                                            {index !== 0 && (
                                                                <div className="col-span-2 mb-4 flex justify-start">
                                                                    <div className="hover:cursor-pointer" onClick={() => removeForm(index, form)}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="red" viewBox="0 0 24 24" strokeWidth={1.5} stroke="white" className="w-12 h-12">
                                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                                        </svg>

                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div className="p-2">
                                                                <div className="grid grid-cols-12">
                                                                    <div className="col-span-1 md:col-span-1">
                                                                        <input
                                                                            type="radio"
                                                                            id={`maker-${index}`} // Include index to make the ID unique
                                                                            name={`role-${index}`} // Include index to make the name unique
                                                                            checked={form.role === 'maker'}
                                                                            className="form-radio h-5 w-5 text-indigo-600"
                                                                            onChange={(e) => handleChange(index, e)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-span-11 md:col-span-11">
                                                                        <label
                                                                            htmlFor={`maker-${index}`} // Use the same ID here
                                                                            className="ml-2 text-gray-700"
                                                                        >
                                                                            Maker
                                                                        </label><br />
                                                                        <label className="ml-1 text-red-700 text-sm font-semibold">(Only Maker / Creation rights)</label>
                                                                    </div>
                                                                </div>
                                                                <div className="grid grid-cols-12">
                                                                    <div className="col-span-1 md:col-span-1">
                                                                        <input
                                                                            type="radio"
                                                                            id={`checker-${index}`}
                                                                            name={`role-${index}`}
                                                                            checked={form.role === 'checker'}
                                                                            className="form-radio h-5 w-5 text-indigo-600"
                                                                            onChange={(e) => handleChange(index, e)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-span-11 md:col-span-11">
                                                                        <label
                                                                            htmlFor={`checker-${index}`}
                                                                            className="ml-2 text-gray-700"
                                                                        >
                                                                            Checker
                                                                        </label>
                                                                        <br />
                                                                        <label className="ml-1 text-red-700 text-sm font-semibold">(Only verification and approval rights)</label>
                                                                    </div>
                                                                </div>
                                                                <div className="grid grid-cols-12">
                                                                    <div className="col-span-1 md:col-span-1">
                                                                        <input
                                                                            type="radio"
                                                                            id={`checker_maker-${index}`}
                                                                            name={`role-${index}`}
                                                                            checked={form.role === 'checker_maker'}
                                                                            className="form-radio h-5 w-5 text-indigo-600"
                                                                            onChange={(e) => handleChange(index, e)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-span-11 md:col-span-11">
                                                                        <label
                                                                            htmlFor={`checker_maker-${index}`}
                                                                            className="ml-2 text-gray-700"
                                                                        >
                                                                            Checker Maker
                                                                        </label>
                                                                        <br />
                                                                        <label className="ml-1 text-red-700 text-sm font-semibold">(Maker and Checker Rights)</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}


                                        {/* <div className="col-span-12 md:col-span-7 lg:col-span-7">
                                            <div className="relative text-center">
                                                <button onClick={handleSubmit} className="vtpRm-action-button">
                                                    Verify & Proceed
                                                </button>
                                                {details?.result.lastCompletedStep >= 4 ? <>
                                                    <span className="skip-btn hover:cursor-pointer py-4 px-4" onClick={SkipStep} >
                                                        Skip this step
                                                    </span>
                                                </> : ''}
                                            </div>
                                        </div> */}
                                        <div className="col-span-12 md:col-span-7 lg:col-span-7">
                                            <div className="relative text-center">
                                                <button onClick={handleSubmit} className="vtpRm-action-button">
                                                    Verify & Proceed
                                                </button>
                                                {details?.result.lastCompletedStep >= 4 && (
                                                    <span className="skip-btn hover:cursor-pointer py-4 px-4" disabled={formIds.some(id => id === '')} onClick={SkipStep}>
                                                        Skip this step
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body >
        </>
    );
}